import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { useI18n } from 'vue-i18n'
import Layout from '@/components/layout/Layout.vue';
import Index from '@/views/Index.vue';
import NewsList from '@/views/NewsList.vue';
import NewsDetail from '@/views/NewsDetail.vue';
import NoticeList from '@/views/NoticeList.vue';
import NoticeDetail from '@/views/NoticeDetail.vue';
import GroupEvents from '@/views/about/GroupEvents.vue';
import About from '@/views/about/About.vue';
import Executives from '@/views/about/Executives.vue';
import ExplosivesBusiness from '@/views/business/ExplosivesBusiness.vue';
import MiningBusiness from '@/views/business/MiningBusiness.vue';
import OverseasBusiness from '@/views/business/OverseasBusiness.vue';
import TechStrength from '@/views/business/TechStrength.vue';
import ESG from '@/views/esg/esg.vue';
import MiningBusinessConstruction from '@/views/business/MiningExplore.vue';
import Honors from '@/views/about/Honors.vue';
import GroupOrganization from '@/views/about/GroupOrganization.vue';
import Video from '@/views/about/Video.vue';
import Contact from '@/views/contact/Contact.vue';
import JoinUs from '@/views/contact/JoinUs.vue';
import RecruitmentList from '@/views/contact/RecruitmentList.vue';
import RecruitmentDetail from '@/views/contact/RecruitmentDetail.vue';
import CoreValues from '@/views/about/CoreValues.vue';
import PresidentSpeech from '@/views/about/PresidentSpeech.vue';
import Productions from '@/views/about/Productions.vue';



const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: Index,
        meta: { seoKey: 'home' } // 绑定SEO key
      },
      { path: 'news', component: NewsList, meta: { seoKey: 'news' } },
      { path: 'news/:id', component: NewsDetail, props: true, meta: { seoKey: 'news' } },
      { path: 'notice', component: NoticeList, meta: { seoKey: 'notice' } },
      { path: 'notice/:id', component: NoticeDetail, props: true, meta: { seoKey: 'notice' } },
      { path: 'notice/esg', component: ESG, meta: { seoKey: 'esg' } },
      { path: 'about/group_events', component: GroupEvents, meta: { seoKey: 'group_events' } },
      { path: 'about', component: About, meta: { seoKey: 'about' } },
      { path: 'about/executives', component: Executives, meta: { seoKey: 'executives' } },
      { path: 'about/honors', component: Honors, meta: { seoKey: 'honors' } },
      { path: 'about/productions', component: Productions, meta: { seoKey: 'production' } },
      { path: 'about/core_value', component: CoreValues, meta: { seoKey: 'core_value' } },
      { path: 'about/president_speech', component: PresidentSpeech, meta: { seoKey: 'president_speech' } },
      { path: 'about/group_structure', component: GroupOrganization, meta: { seoKey: 'group_structure' } },
      { path: 'about/video', component: Video, meta: { seoKey: 'video' } },
      { path: 'business/mining', component: MiningBusiness, meta: { seoKey: 'mining' } },
      { path: 'business/mine-construction', component: MiningBusinessConstruction, meta: { seoKey: 'mine-construction' } },
      { path: 'business/explosives', component: ExplosivesBusiness, meta: { seoKey: 'explosives' } },
      { path: 'business/overseas', component: OverseasBusiness, meta: { seoKey: 'overseas' } },
      { path: 'business/technical', component: TechStrength, meta: { seoKey: 'technical' } },
      { path: 'contact', component: Contact, meta: { seoKey: 'contact' } },
      { path: 'join_us', component: JoinUs, meta: { seoKey: 'join_us' } },
      { path: 'recruitment', component: RecruitmentList, meta: { seoKey: 'recruitment_list' } },
      { path: 'recruitment/:id', component: RecruitmentDetail, props: true, meta: { seoKey: 'recruitmentDetail' } },
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由前置守卫：全局处理 SEO标题 + 语言 + meta标签
// 路由守卫完整修正版 - 无任何报错
router.beforeEach((to, from, next) => {
  const i18n = (window as any).$i18n;
  const currentLang = i18n.global.locale.value; // ✅ 写法正确，实时读取
  const $t = i18n.global.t;
  const seoKey = to.meta.seoKey as string;

  console.log('路由守卫获取的语言：', currentLang); // 这次一定是正确的！

  if (seoKey) {
    const pageTitle = $t(`seo.${seoKey}.title`);
    document.title = pageTitle as string;

    const langMap = {
      cn: 'cn',
      tc: 'tc',
      en: 'en'
    } as any;
    document.documentElement.lang = langMap[currentLang] || 'cn';

    const metaDesc = $t(`seo.${seoKey}.desc`) as string;
    let descTag = document.querySelector('meta[name="description"]');
    if (!descTag) {
      descTag = document.createElement('meta');
      descTag.setAttribute('name', 'description');
      document.head.appendChild(descTag);
    }
    descTag.setAttribute('content', metaDesc);

    const metaKeywords = $t(`common.keywords`) as string;
    let keyTag = document.querySelector('meta[name="keywords"]');
    if (!keyTag) {
      keyTag = document.createElement('meta');
      keyTag.setAttribute('name', 'keywords');
      document.head.appendChild(keyTag);
    }
    keyTag.setAttribute('content', metaKeywords);
  }

  next();
});
export default router